import { Component } from '@angular/core';
import { OrderEditingService } from '@app/pages/order-editing/order-editing.service';
import { OrderEditingFormTab } from '../../../../order-editing-form.component';

@Component({
  selector: 'address-validation-configurations',
  standalone: false,
  templateUrl: './address-validation-configurations.component.html',
  styleUrl: './address-validation-configurations.component.scss',
})
export class AddressValidationConfigurationsComponent {
  constructor(public orderEditingService: OrderEditingService) {}

  openSettings(): void {
    this.orderEditingService.setActiveTab(OrderEditingFormTab.SETTINGS);
  }
}
